<mat-dialog-content>
    <span [innerHTML]="data"></span>
</mat-dialog-content>
<mat-dialog-actions align="right">
    <button mat-raised-button
            color="warn"
            (click)="onSubmit()">OK
    </button>
</mat-dialog-actions>
